export default __webpack_public_path__ + "static/media/img-contact.add0907d.jpg";